import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {findDOMNode} from 'react-dom';

@inject("store")
@observer
export default class QuestionInfo extends Component {

    constructor(props) {
        super(props);
    }

    hideModal = () => {
        this.props.store.hideModal()
    };

    componentDidMount() {

        const sidebar = findDOMNode(this.refs.sidebar);

        if ($(sidebar).length) {
            new StickySidebar(sidebar, {
                topSpacing: 20,
                bottomSpacing: 20,
                containerSelector: '.main-content',
                innerWrapperSelector: '.sidebar__inner'
            });
        }
    }

    render() {
        let {info, questionCount, question, hasResult} = this.props.store;

        const title = !hasResult ? question : 'Verdt å vite';
        const questionNumber = !hasResult ? <span>{questionCount}</span> : null;
        const resultClass = hasResult ? "result" : "";

        return (
            <div className="sidebar" ref="sidebar">
                <div className="sidebar__inner">
                    <div className="question-information">
                        <div className="question-information-text">
                            <div className="inner">
                                <span className={"info-title " + resultClass}>{questionNumber}</span>
                                <span className="info-title-no2">{title}</span>
                                <div dangerouslySetInnerHTML={{__html: info}}/>
                                <span className="info-confirm" onClick={this.hideModal}>OK</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/QuestionInfo.js